"use strict";

module.exports = /* @ngInject */ function(
  $q,
  winINetCookieRepository,
  rediVersionCheck
) {
  var that = this;

  that.getRtDevice = function() {
    return rediVersionHandlesWinINet().then(function(
      rediVersionHandlesWinINet
    ) {
      if (rediVersionHandlesWinINet) {
        return winINetCookieRepository
          .getRtDeviceCookie()
          .then(function(rtDeviceCookie) {
            if (rtDeviceCookie) {
              return rtDeviceCookie.value;
            }
          });
      }
    });
  };

  function rediVersionHandlesWinINet() {
    return rediVersionCheck
      .isExpectingVersionFromRedi()
      .then(function(isExpecting) {
        return (
          isExpecting && rediVersionCheck.isGreaterThanOrEqualTo("17.0.2.002")
        );
      });
  }

  that.setRtDeviceCookies = function(cookiesAsArrayOfStrings) {
    return winINetCookieRepository.setRtDeviceCookies(cookiesAsArrayOfStrings);
  };
};



// WEBPACK FOOTER //
// ./app/business/cookieRepository.js